import { render, staticRenderFns } from "./findpass.vue?vue&type=template&id=0a3d983e&scoped=true"
import script from "./findpass.vue?vue&type=script&lang=js"
export * from "./findpass.vue?vue&type=script&lang=js"
import style0 from "./findpass.vue?vue&type=style&index=0&id=0a3d983e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3d983e",
  null
  
)

export default component.exports